import React from "react";
import UsersList from "@/components/Users/MaintainUsers";

const Users = () => {
  return (
    <div className="h-full">
      <UsersList />
    </div>
  );
};

export default Users;
